import { instance4, TYPE_INSTANCE2 } from "App/constants";
import { fetchData, isNull } from "App/utils/helpers";
import { useEffect, useState } from "react";
import { LIST_URL_REGISTRASI } from "utils/registrations";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.masterHargaFormula.get;
export const urlUpdate = LIST_URL_WAREHOUSE.masterHargaFormula.update;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  harga_id: null,
  harga_name: "Pilih Harga",
};

export const RESET_STATE_MASTER_FORMULA_HARGA = {
  id: "",
  harga_id: "",
  formula_id: "",
  namaMsHarga: "",
  namaFormula: "",
  jenisTarif: [],
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "namaFormula",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaMsHarga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
    minWidth: "150px",
  },
];

export const useTarif = () => {
  const [tarif, setTarif] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await fetchData(
        TYPE_INSTANCE2,
        LIST_URL_REGISTRASI.masterKelasKunjungan.getTarif
      );
      if (response) {
        const listTarif = [];
        await response?.map((e) =>
          listTarif.push({
            id: e.id,
            name: e.name,
          })
        );

        setTarif(listTarif);
      }
    })();
  }, []);

  return tarif;
};

export const getByFilterFormulaHarga = async (
  harga_id,
  pages,
  limit,
  length
) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: parseInt(limit) * length,
      harga_id: isNull(harga_id) ? 1 : harga_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          // count: parseInt(res.totalData),
          count: 17,
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
